module.exports = "/fonts/quark-light.svg?a7df9071d99b3209510f5a72d562009f";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/fonts/Quark/quark-light.svg
// module id = FOl0
// module chunks = 0